import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { extractApiErrorMessage } from '@hunch/frontend-shared/utils';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SKIP_ERROR_SNACKBAR } from '@app/core/interseptors/skip-error-snackbar.token';
import { SnackBarService } from '@services/snack-bar.service';

export const CustomMessagesEndpointsMap: Record<string, Record<number | string, string>> = {
  '/sports-events': {
    409: 'This external sport event is used in another tenant'
  },
  '/info-popup-tabs/mark-unseen': {
    429: 'Updating is in progress please try again a bit later'
  }
};

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private snackBarService = inject(SnackBarService);

  intercept(request: HttpRequest<string | object>, next: HttpHandler): Observable<HttpEvent<string | object>> {
    const skipSnackBar = request.context.get(SKIP_ERROR_SNACKBAR);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!skipSnackBar) {
          const errorMessage = this.getErrorMessage(error);
          this.showErrorMessage(errorMessage, error);
        }

        return throwError(() => error);
      })
    );
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    const path = error.error?.path;
    const status = error.error?.statusCode;
    const pathMessages = CustomMessagesEndpointsMap[path];
    const customMessage = pathMessages?.[status] || pathMessages?.['*'];

    if (error.status === 500) {
      return 'Server error';
    } else if (customMessage) {
      return customMessage;
    } else {
      return extractApiErrorMessage(error.error, 'An error occurred. Please try again later.');
    }
  }

  private showErrorMessage(errorMessage: string, error: HttpErrorResponse): void {
    if (errorMessage) {
      this.snackBarService.showSnackBar(errorMessage, true);
    } else {
      console.error('Unknown error occurred:', error);
    }
  }
}
